module.exports = __webpack_public_path__ + "img/14.3b3f4c15.png";